export type TopicSourceTrust = 4 | 5;

export type TopicContentSource = {
  sourceId: string;
  topicId: string;
  title: string;
  publisher: string;
  url: string;
  trust: TopicSourceTrust;
  jurisdiction: "australia" | "nsw";
  checkedAt: string;
  verificationMethod: string;
  reviewStatus:
    | "live_verified"
    | "official_index_verified"
    | "official_document_verified"
    | "official_access_limited"
    | "supporting_source_only";
  claimScope: string;
  followUp: string | null;
};

export const TOPIC_CONTENT_SOURCES = [
  {
    sourceId: "school-source-finder",
    topicId: "school",
    title: "NSW Public School Finder",
    publisher: "NSW Department of Education",
    url: "https://schoolfinder.education.nsw.gov.au/",
    trust: 4,
    jurisdiction: "nsw",
    checkedAt: "2026-09-15",
    verificationMethod: "공식 School Finder 서비스에서 주소 기반 local school 검색과 specialist support 문의 경로 확인",
    reviewStatus: "live_verified",
    claimScope: "실제 거주 주소로 지정 local public school과 주변 학교를 찾는 출발점",
    followUp: "경계와 학교 정보는 바뀔 수 있으므로 신청 전에 해당 학교에 주소와 학년을 재확인",
  },
  {
    sourceId: "school-source-enrolment",
    topicId: "school",
    title: "Enrolment",
    publisher: "NSW Department of Education",
    url: "https://education.nsw.gov.au/schooling/parents-and-carers/choosing-a-school-setting/enrolment",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-09-15",
    verificationMethod: "공식 enrolment 본문에서 2026 절차 변경, local area, non-local, 온라인·영어 신청과 개인정보 안내 확인",
    reviewStatus: "live_verified",
    claimScope: "NSW Government school의 local·non-local 신청 경로와 신청서 기본 규칙",
    followUp: "학교별 온라인 신청 가능 여부와 현재 non-local 기준을 해당 학교에서 확인",
  },
  {
    sourceId: "school-source-primary",
    topicId: "school",
    title: "Primary school enrolment",
    publisher: "NSW Department of Education",
    url: "https://education.nsw.gov.au/schooling/parents-and-carers/choosing-a-school-setting/enrolment/primary-school-enrolment",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-09-15",
    verificationMethod: "공식 페이지 본문에서 신원·주소·AIR·법원명령·건강지원 자료와 temporary resident 서류 안내 확인",
    reviewStatus: "live_verified",
    claimScope: "신규·전학·temporary resident 공립학교 enrolment의 준비 서류와 지원 필요 알림",
    followUp: "학생 상황별 추가 자료와 원본 제시 방식은 해당 학교에서 확인",
  },
  {
    sourceId: "school-source-procedures",
    topicId: "school",
    title: "Enrolment in Kindergarten to Year 12 procedures",
    publisher: "NSW Department of Education",
    url: "https://education.nsw.gov.au/policy-library/policies/pd-2002-0006-01",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-09-15",
    verificationMethod: "현행 공식 절차에서 proof of address, 100-point 확인의 적용 범위·조정 사유와 non-local 심사 기준 확인",
    reviewStatus: "live_verified",
    claimScope: "주소 증명 부족, enrolment buffer, non-local 신청과 추가 지원이 필요한 학생의 공식 처리 원칙",
    followUp: "정책 개정과 학교별 공개 기준을 신청 시점에 다시 확인",
  },
  {
    sourceId: "school-source-2026-update",
    topicId: "school",
    title: "Updates to enrolment procedures",
    publisher: "NSW Department of Education",
    url: "https://education.nsw.gov.au/content/dam/main-education/going-to-a-public-school/media/documents/translated-documents-/2026-enrolment-policy-updates/english-enrolment-policy-changes.pdf",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-09-15",
    verificationMethod: "2026 공식 안내 PDF에서 non-local 신청 흐름, 주소·신원 자료가 부족한 상황, temporary resident와 통역 경로 확인",
    reviewStatus: "official_document_verified",
    claimScope: "2026 enrolment 변경 사항과 특수 상황에서 학교에 문의해야 할 공식 경로",
    followUp: "2027 이후 신청은 해당 연도 NSW enrolment update를 새로 확인",
  },
  {
    sourceId: "abn-source-entitlement",
    topicId: "abn",
    title: "ABN entitlement",
    publisher: "Australian Business Register",
    url: "https://www.abr.gov.au/business-super-funds-charities/applying-abn/abn-entitlement",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-15",
    verificationMethod: "공식 페이지 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "ABN 신청 자격과 직원·계약자 구분",
    followUp: null,
  },
  {
    sourceId: "abn-source-applying",
    topicId: "abn",
    title: "Applying for an ABN",
    publisher: "Australian Business Register",
    url: "https://www.abr.gov.au/business-super-funds-charities/applying-abn",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-15",
    verificationMethod: "공식 페이지 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "ABN 신청 절차와 신청 결과",
    followUp: null,
  },
  {
    sourceId: "abn-source-preparation",
    topicId: "abn",
    title: "What you need for your ABN application",
    publisher: "Australian Business Register",
    url: "https://www.abr.gov.au/business-super-funds-charities/applying-abn/what-you-need-your-abn-application",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-15",
    verificationMethod: "공식 페이지 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "ABN 신청 전 준비 정보",
    followUp: null,
  },
  {
    sourceId: "abn-source-business-guide",
    topicId: "abn",
    title: "Register for an Australian Business Number",
    publisher: "Australian Government business.gov.au",
    url: "https://business.gov.au/registrations/register-for-an-australian-business-number-abn",
    trust: 4,
    jurisdiction: "australia",
    checkedAt: "2026-07-15",
    verificationMethod: "공식 정부 안내 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "무료 신청, ABN 기본 개념과 후속 등록",
    followUp: null,
  },
  {
    sourceId: "abn-source-maintenance",
    topicId: "abn",
    title: "Updating or cancelling your ABN",
    publisher: "Australian Business Register",
    url: "https://www.abr.gov.au/business-super-funds-charities/updating-or-cancelling-your-abn",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-15",
    verificationMethod: "공식 페이지 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "ABN 정보 변경과 취소",
    followUp: null,
  },
  {
    sourceId: "abn-source-lookup",
    topicId: "abn",
    title: "ABN Lookup",
    publisher: "Australian Business Register",
    url: "https://abr.business.gov.au/home",
    trust: 4,
    jurisdiction: "australia",
    checkedAt: "2026-07-15",
    verificationMethod: "공식 조회 서비스 확인",
    reviewStatus: "live_verified",
    claimScope: "ABN 공개 등록 상태 조회",
    followUp: null,
  },
  {
    sourceId: "tfn-source-overview",
    topicId: "tfn",
    title: "What is a tax file number?",
    publisher: "Australian Taxation Office",
    url: "https://www.ato.gov.au/individuals-and-families/tax-file-number/what-is-a-tax-file-number",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "ATO 공식 검색 색인과 공식 콘텐츠 API 설명 확인",
    reviewStatus: "official_index_verified",
    claimScope: "TFN 정의, 평생 유지, 무료 신청과 보안",
    followUp: "ATO 페이지 자동 접근 제한으로 다음 검토 때 브라우저에서 본문 재확인",
  },
  {
    sourceId: "tfn-source-apply",
    topicId: "tfn",
    title: "Apply for a TFN",
    publisher: "Australian Taxation Office",
    url: "https://www.ato.gov.au/individuals-and-families/tax-file-number/apply-for-a-tfn",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "ATO 공식 검색 색인과 공식 콘텐츠 API 설명 확인",
    reviewStatus: "official_access_limited",
    claimScope: "상황별 TFN 신청 경로",
    followUp: "실제 신청 직전에 ATO 페이지의 현재 경로와 요구사항 재확인",
  },
  {
    sourceId: "tfn-source-migrants",
    topicId: "tfn",
    title: "Permanent migrants and temporary visitors – TFN application",
    publisher: "Australian Taxation Office",
    url: "https://www.ato.gov.au/individuals-and-families/tax-file-number/apply-for-a-tfn/permanent-migrants-and-temporary-visitors-tfn-application",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "ATO 공식 검색 색인과 공식 콘텐츠 API 설명 확인",
    reviewStatus: "official_access_limited",
    claimScope: "호주 내 영주권자·임시비자 방문자의 일반 신청 경로",
    followUp: "비자별 세부 자격과 온라인 신청 화면은 ATO에서 직접 재확인",
  },
  {
    sourceId: "tfn-source-residents",
    topicId: "tfn",
    title: "Australian residents – TFN application",
    publisher: "Australian Taxation Office",
    url: "https://www.ato.gov.au/individuals-and-families/tax-file-number/apply-for-a-tfn/australian-residents-tfn-application",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "ATO 공식 검색 색인과 공식 양식 안내 확인",
    reviewStatus: "official_document_verified",
    claimScope: "호주 세법상 거주자의 신청 선택지와 신원 확인",
    followUp: "Australia Post·Services Australia 이용 조건은 신청 시점에 재확인",
  },
  {
    sourceId: "tfn-source-declaration",
    topicId: "tfn",
    title: "Tax file number declaration",
    publisher: "Australian Taxation Office",
    url: "https://www.ato.gov.au/TFNdec",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "ATO 공식 페이지 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "TFN declaration의 목적과 취업 후 제출 절차",
    followUp: "개인별 원천징수 선택은 ATO 또는 등록 세무사에게 확인",
  },
  {
    sourceId: "tfn-source-security",
    topicId: "tfn",
    title: "Lost or stolen TFN",
    publisher: "Australian Taxation Office",
    url: "https://www.ato.gov.au/individuals-and-families/tax-file-number/lost-or-stolen-tfn",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "ATO 공식 검색 색인과 연결된 개인정보 보호 안내 확인",
    reviewStatus: "official_index_verified",
    claimScope: "기존 TFN 찾기, 분실·도용 대응과 안전한 공유",
    followUp: "도용·오용이 의심되면 ATO 공식 연락처를 직접 확인하고 즉시 신고",
  },
  {
    sourceId: "renting-source-application",
    topicId: "renting",
    title: "Finding and applying for a rental property",
    publisher: "NSW Government",
    url: "https://www.nsw.gov.au/housing-and-construction/renting-a-place-to-live/starting-a-residential-tenancy/finding-and-applying-for-a-rental-property",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-16",
    verificationMethod: "NSW Government 공식 페이지 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "매물 점검, 신청, holding fee와 입주 시작 비용",
    followUp: null,
  },
  {
    sourceId: "renting-source-signing",
    topicId: "renting",
    title: "Signing a lease and moving in",
    publisher: "NSW Government",
    url: "https://www.nsw.gov.au/housing-and-construction/renting-a-place-to-live/starting-a-residential-tenancy/signing-a-lease-and-moving",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-16",
    verificationMethod: "NSW Government 공식 페이지 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "계약 전 제공 문서와 입주 절차",
    followUp: null,
  },
  {
    sourceId: "renting-source-tenant-statement",
    topicId: "renting",
    title: "Tenant information statement",
    publisher: "NSW Government",
    url: "https://www.nsw.gov.au/housing-and-construction/rental-forms-surveys-and-data/resources/tenant-information-statement",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-16",
    verificationMethod: "NSW Government 공식 페이지 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "계약의 구속력, 서명 전 확인사항과 cooling-off 부재",
    followUp: null,
  },
  {
    sourceId: "renting-source-bonds",
    topicId: "renting",
    title: "Rental Bonds Online for tenants",
    publisher: "NSW Government",
    url: "https://www.nsw.gov.au/housing-and-construction/renting-a-place-to-live/residential-rental-bonds/rental-bonds-online-for-tenants",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-16",
    verificationMethod: "NSW Government 공식 페이지 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "bond 상한과 Rental Bonds Online 이용",
    followUp: null,
  },
  {
    sourceId: "renting-source-repairs",
    topicId: "renting",
    title: "Getting repairs done",
    publisher: "NSW Government",
    url: "https://www.nsw.gov.au/housing-and-construction/renting-a-place-to-live/getting-repairs-done",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-16",
    verificationMethod: "NSW Government 공식 페이지 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "일반·긴급 수리 요청, 기록 보관과 분쟁 해결",
    followUp: "긴급 수리의 현재 정의와 비용 한도는 조치 직전 공식 페이지에서 재확인",
  },
  {
    sourceId: "renting-source-ending",
    topicId: "renting",
    title: "Moving out of a rental home",
    publisher: "NSW Government",
    url: "https://www.nsw.gov.au/housing-and-construction/renting-a-place-to-live/ending-a-residential-tenancy/moving-out-of-a-rental-home",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-16",
    verificationMethod: "NSW Government 공식 페이지 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "퇴거 통지, 열쇠 반환, 최종 condition report와 bond 환급",
    followUp: "계약 유형과 종료 사유별 notice period는 통지 전 공식 페이지에서 재확인",
  },
  {
    sourceId: "jobs-source-applications",
    topicId: "jobs",
    title: "Improve your job applications",
    publisher: "Workforce Australia",
    url: "https://www.workforceaustralia.gov.au/individuals/coaching/job-applications",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "Australian Government 공식 페이지 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "이력서, cover letter와 지원서 준비",
    followUp: null,
  },
  {
    sourceId: "jobs-source-interview",
    topicId: "jobs",
    title: "Prepare for a job interview",
    publisher: "Workforce Australia",
    url: "https://www.workforceaustralia.gov.au/individuals/coaching/job-applications/job-interviews",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "Australian Government 공식 페이지 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "고용주 조사, 면접 준비와 조건 질문",
    followUp: null,
  },
  {
    sourceId: "jobs-source-before-starting",
    topicId: "jobs",
    title: "Before starting employment",
    publisher: "Fair Work Ombudsman",
    url: "https://www.fairwork.gov.au/starting-employment/before-starting-employment",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "Fair Work Ombudsman 공식 페이지 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "채용 전 조건, probation, 급여, payslip와 unpaid trial",
    followUp: "실제 시작 전 적용 award와 현재 급여율을 Pay and Conditions Tool에서 재확인",
  },
  {
    sourceId: "jobs-source-unpaid-work",
    topicId: "jobs",
    title: "Work experience and internships",
    publisher: "Fair Work Ombudsman",
    url: "https://www.fairwork.gov.au/starting-employment/unpaid-work/work-experience-and-internships",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "Fair Work Ombudsman 공식 페이지 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "unpaid trial, work experience와 고용관계 구분",
    followUp: "무급 근무의 적법성은 구체적인 업무와 고용관계에 따라 달라지므로 개별 확인",
  },
  {
    sourceId: "jobs-source-migrant-rights",
    topicId: "jobs",
    title: "Visa holders and migrants",
    publisher: "Fair Work Ombudsman",
    url: "https://www.fairwork.gov.au/find-help-for/visa-holders-migrants",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "Fair Work Ombudsman 공식 페이지 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "비자 소지자의 직장 권리, 근무 조건과 도움 요청",
    followUp: "개인의 비자 근무 조건은 Home Affairs VEVO에서 별도 확인",
  },
  {
    sourceId: "jobs-source-scams",
    topicId: "jobs",
    title: "Jobs and employment scams",
    publisher: "Scamwatch",
    url: "https://www.scamwatch.gov.au/types-of-scams/jobs-and-employment-scams",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "National Anti-Scam Centre 공식 페이지 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "가짜 채용 제안의 신호, 예방과 피해 대응",
    followUp: null,
  },
  {
    sourceId: "nsw-driver-source-overseas-driving",
    topicId: "nsw-driver-licence",
    title: "Driving with an overseas or interstate licence in NSW",
    publisher: "NSW Government",
    url: "https://www.nsw.gov.au/driving-boating-and-transport/driver-and-rider-licences/visiting-or-moving-to-nsw/visiting-from-overseas-or-interstate",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-16",
    verificationMethod: "NSW Government 공식 페이지 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "해외면허 사용 조건과 3개월·6개월 전환 기한",
    followUp: "입국일, NSW 거주 시작일과 비자 상태에 따른 개인별 기한 재확인",
  },
  {
    sourceId: "nsw-driver-source-temporary",
    topicId: "nsw-driver-licence",
    title: "Apply for a NSW licence as a temporary overseas visitor",
    publisher: "Service NSW",
    url: "https://www.service.nsw.gov.au/transaction/apply-for-a-nsw-licence-as-a-temporary-overseas-visitor",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-16",
    verificationMethod: "Service NSW 공식 페이지 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "임시비자 소지자의 NSW 면허 신청과 준비 서류",
    followUp: "신청 전 비자 상태와 현재 요구 서류를 Service NSW에서 확인",
  },
  {
    sourceId: "nsw-driver-source-transfer",
    topicId: "nsw-driver-licence",
    title: "Transfer an overseas driver licence",
    publisher: "Service NSW",
    url: "https://www.service.nsw.gov.au/transaction/transfer-an-overseas-driver-licence",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-16",
    verificationMethod: "Service NSW 공식 페이지 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "영주권자·시민권자의 전환 절차, 원본 면허와 허용 번역",
    followUp: "validation letter 필요 여부는 방문 전 Service NSW에 확인",
  },
  {
    sourceId: "nsw-driver-source-exemptions",
    topicId: "nsw-driver-licence",
    title: "Knowledge and driving test exemptions",
    publisher: "NSW Government",
    url: "https://www.nsw.gov.au/driving-boating-and-transport/driver-and-rider-licences/visiting-or-moving-to-nsw/moving-your-overseas-licence/knowledge-and-driving-test-exemptions",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-16",
    verificationMethod: "2026-02-01 개정 후 NSW Government 공식 페이지 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "현재 인정 국가 목록과 한국 면허 시험 면제 종료",
    followUp: "시험 예약 전 인정 국가 목록과 개인별 면제 여부 재확인",
  },
  {
    sourceId: "nsw-driver-source-eligibility",
    topicId: "nsw-driver-licence",
    title: "Check which licence you are eligible for",
    publisher: "NSW Government",
    url: "https://www.nsw.gov.au/driving-boating-and-transport/driver-and-rider-licences/visiting-or-moving-to-nsw/moving-your-overseas-licence/check-your-licence-eligibility",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-16",
    verificationMethod: "NSW Government 공식 페이지 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "해외면허 보유 기간별 NSW 면허 등급",
    followUp: "면허 이력과 유효성에 따른 등급은 Service NSW에서 최종 확인",
  },
  {
    sourceId: "nsw-driver-source-service-centre",
    topicId: "nsw-driver-licence",
    title: "Visit a service centre – overseas licence",
    publisher: "NSW Government",
    url: "https://www.nsw.gov.au/driving-boating-and-transport/driver-and-rider-licences/visiting-or-moving-to-nsw/moving-your-overseas-licence/visit-a-service-centre",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-16",
    verificationMethod: "NSW Government 공식 페이지 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "Service NSW 방문, 시력검사, 임시면허와 시험 불합격 결과",
    followUp: "방문 전 예약·비용·시험 가능 일정을 최신 페이지에서 확인",
  },
  {
    sourceId: "medicare-source-enrolment",
    topicId: "medicare",
    title: "Enrolling in Medicare",
    publisher: "Services Australia",
    url: "https://www.servicesaustralia.gov.au/enrolling-medicare?context=60092",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "Services Australia 공식 페이지 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "Medicare 가입 대상, 온라인·양식 신청과 가족 등록",
    followUp: "신청 직전 현재 비자별 자격과 온라인 신청 가능 여부 재확인",
  },
  {
    sourceId: "medicare-source-permanent-resident",
    topicId: "medicare",
    title: "Enrolling in Medicare if you’re an Australian permanent resident",
    publisher: "Services Australia",
    url: "https://www.servicesaustralia.gov.au/enrolling-medicare-if-youre-australian-permanent-resident?context=60092",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "Services Australia 공식 페이지 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "영주권자와 일부 영주권 신청자의 가입 자격·시작일",
    followUp: "parent visa와 영주권 심사·항소 상태는 개인별 추가 확인",
  },
  {
    sourceId: "medicare-source-documents",
    topicId: "medicare",
    title: "Documents to enrol in Medicare if you've applied for permanent residency",
    publisher: "Services Australia",
    url: "https://www.servicesaustralia.gov.au/documents-to-enrol-medicare-if-youve-applied-for-permanent-residency?context=60092",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "Services Australia 공식 페이지 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "영주권 신청자의 여권·ImmiCard·신청 증빙과 추가 가족관계 서류",
    followUp: "제출 전 각 가족 구성원에게 필요한 현재 서류 목록 재확인",
  },
  {
    sourceId: "medicare-source-card",
    topicId: "medicare",
    title: "Your Medicare card",
    publisher: "Services Australia",
    url: "https://www.servicesaustralia.gov.au/your-medicare-card?context=60092",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "Services Australia 공식 페이지 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "카드 발급, digital card, green·blue·yellow 카드와 교체",
    followUp: null,
  },
  {
    sourceId: "medicare-source-benefits",
    topicId: "medicare",
    title: "Getting Medicare benefits",
    publisher: "Services Australia",
    url: "https://www.servicesaustralia.gov.au/getting-medicare-benefits?context=60092",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "Services Australia 공식 페이지 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "Medicare benefit 수령을 위한 myGov와 은행정보 관리",
    followUp: "진료 전 provider에 bulk billing·예상 gap과 청구 방식을 확인",
  },
  {
    sourceId: "medicare-source-rhca",
    topicId: "medicare",
    title: "About reciprocal health care agreements",
    publisher: "Services Australia",
    url: "https://www.servicesaustralia.gov.au/about-reciprocal-health-care-agreements?context=22481",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "Services Australia 공식 RHCA 국가 목록 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "상호 의료 협정 11개국과 한국 미포함 확인",
    followUp: "방문자 가입을 판단하기 전에 최신 RHCA 국가 목록 재확인",
  },
  {
    sourceId: "mygov-account-source-create",
    topicId: "mygov-account",
    title: "Create a myGov account",
    publisher: "myGov",
    url: "https://my.gov.au/en/about/help/mygov-website/create-mygov-account",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "myGov 공식 도움말 본문과 최종 업데이트 날짜 확인",
    reviewStatus: "live_verified",
    claimScope: "이메일 또는 Digital ID를 이용한 계정 생성과 정부 서비스 연결 안내",
    followUp: "계정 생성 직전 현재 제공되는 가입 방식과 화면 문구 재확인",
  },
  {
    sourceId: "mygov-account-source-sign-in-help",
    topicId: "mygov-account",
    title: "myGov sign in help",
    publisher: "myGov",
    url: "https://my.gov.au/en/about/help/mygov-website/help-using-your-account/mygov-sign-in-help",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "myGov 공식 로그인 도움말의 복구·잠금·대체 로그인 경로 확인",
    reviewStatus: "live_verified",
    claimScope: "username·password·SMS code·passkey 문제와 계정 복구 선택지",
    followUp: "기존 계정에 접근할 수 없는 경우 새 계정을 만들기 전에 최신 복구 경로 확인",
  },
  {
    sourceId: "mygov-account-source-link-services",
    topicId: "mygov-account",
    title: "Link services to your account",
    publisher: "myGov",
    url: "https://my.gov.au/en/about/help/mygov-website/link-services-to-your-account",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "myGov 공식 서비스 연결 목록과 서비스별 연결 안내 확인",
    reviewStatus: "live_verified",
    claimScope: "myGov에서 연결 가능한 정부 서비스와 서비스별 연결 시작 경로",
    followUp: "연결하려는 기관의 최신 질문·신원확인 요구사항은 해당 서비스 페이지에서 재확인",
  },
  {
    sourceId: "mygov-account-source-linking-code",
    topicId: "mygov-account",
    title: "Use a linking code",
    publisher: "myGov",
    url: "https://my.gov.au/en/about/help/mygov-website/link-services-to-your-account/use-a-linking-code",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "myGov 공식 linking code 도움말 본문 확인",
    reviewStatus: "live_verified",
    claimScope: "Centrelink·Child Support·Medicare용 일회성 linking code의 용도와 발급 경로",
    followUp: "전화 또는 방문 전 대상 서비스의 공식 연락처와 신원확인 준비물을 재확인",
  },
  {
    sourceId: "mygov-account-source-security",
    topicId: "mygov-account",
    title: "How you can protect your myGov account",
    publisher: "myGov",
    url: "https://my.gov.au/en/about/privacy-and-security/security/how-you-can-protect-your-mygov-account",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "myGov 공식 보안 안내의 MFA·passkey·계정 기록 권고 확인",
    reviewStatus: "live_verified",
    claimScope: "안전한 로그인 방식, security review, 계정 기록과 기기 보안",
    followUp: "사용 기기와 password manager가 지원하는 로그인 방식을 설정 전에 확인",
  },
  {
    sourceId: "mygov-account-source-contact",
    topicId: "mygov-account",
    title: "Contact myGov or your services",
    publisher: "myGov",
    url: "https://my.gov.au/en/about/help/contact",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "myGov 공식 연락 페이지의 지원 범위와 기관별 문의 분리 확인",
    reviewStatus: "live_verified",
    claimScope: "myGov helpdesk 지원 범위, 공식 온라인 도움과 연결 서비스 문의 경로",
    followUp: "전화번호와 운영시간은 연락 직전 공식 페이지에서 재확인",
  },
  {
    sourceId: "australian-bank-account-source-transaction-account",
    topicId: "australian-bank-account",
    title: "Transaction accounts and debit cards",
    publisher: "ASIC Moneysmart",
    url: "https://moneysmart.gov.au/banking/transaction-accounts-and-debit-cards",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "ASIC Moneysmart 공식 안내의 계좌 용도, 수수료, overdraft와 비교 항목 확인",
    reviewStatus: "live_verified",
    claimScope: "일상 거래계좌·debit card의 용도와 계좌 선택 시 비교할 비용·기능",
    followUp: "신청 직전 선택한 은행의 최신 상품 조건과 수수료표 재확인",
  },
  {
    sourceId: "australian-bank-account-source-identification",
    topicId: "australian-bank-account",
    title: "Customer identification and verification",
    publisher: "AUSTRAC",
    url: "https://www.austrac.gov.au/business/core-guidance/customer-identification-and-verification",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "AUSTRAC 공식 KYC 안내에서 서비스 제공 전 고객 식별·확인 의무 확인",
    reviewStatus: "live_verified",
    claimScope: "은행이 계좌 개설 과정에서 본인 확인 정보와 추가 KYC 자료를 요구하는 이유",
    followUp: "허용 서류와 전자 확인 방식은 신청할 은행의 공식 안내에서 재확인",
  },
  {
    sourceId: "australian-bank-account-source-deposit-protection",
    topicId: "australian-bank-account",
    title: "Financial Claims Scheme: Banks, building societies and credit unions",
    publisher: "Australian Prudential Regulation Authority",
    url: "https://www.apra.gov.au/financial-claims-scheme-banks-building-societies-and-credit-unions",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "APRA 공식 FCS 안내의 적용 기관·계좌·한도와 ADI 기준 확인",
    reviewStatus: "live_verified",
    claimScope: "호주 편입 APRA 승인 ADI의 보호 대상 예금과 계좌 보유자별·ADI별 한도",
    followUp: "큰 금액 예치 전 APRA Deposit Checker와 해당 상품 PDS에서 보호 여부 재확인",
  },
  {
    sourceId: "australian-bank-account-source-epayments-code",
    topicId: "australian-bank-account",
    title: "ePayments Code",
    publisher: "Australian Securities and Investments Commission",
    url: "https://asic.gov.au/regulatory-resources/financial-services/epayments-code/",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "ASIC 공식 ePayments Code 범위와 subscriber 확인 방법 검토",
    reviewStatus: "live_verified",
    claimScope: "전자결제 조건, 무단거래·착오송금 규칙과 금융기관의 Code 가입 여부 확인",
    followUp: "계좌 약관 또는 ASIC 최신 subscriber 목록에서 해당 제공자의 가입 여부 확인",
  },
  {
    sourceId: "australian-bank-account-source-transaction-problems",
    topicId: "australian-bank-account",
    title: "Unauthorised and mistaken transactions",
    publisher: "ASIC Moneysmart",
    url: "https://moneysmart.gov.au/banking/unauthorised-and-mistaken-transactions",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "Moneysmart 공식 안내의 즉시 신고, reference number와 분쟁 단계 확인",
    reviewStatus: "live_verified",
    claimScope: "무단거래·착오송금 발견 시 은행 신고와 내부·외부 분쟁 해결 경로",
    followUp: "문제 발견 즉시 은행에 신고하고 개별 환급 여부는 은행 조사 결과로 확인",
  },
  {
    sourceId: "australian-bank-account-source-security",
    topicId: "australian-bank-account",
    title: "Banking scams",
    publisher: "ASIC Moneysmart",
    url: "https://moneysmart.gov.au/financial-scams/banking-scams",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "Moneysmart 공식 은행 사기 유형과 보호 행동 안내 확인",
    reviewStatus: "live_verified",
    claimScope: "피싱·은행 사칭·원격접속 사기 식별과 공식 앱·번호를 이용한 확인",
    followUp: "사기 의심 시 메시지 링크가 아닌 은행 공식 채널과 Scamwatch 최신 안내 확인",
  },
  {
    sourceId: "australian-bank-account-source-complaints",
    topicId: "australian-bank-account",
    title: "Before making a complaint",
    publisher: "Australian Financial Complaints Authority",
    url: "https://www.afca.org.au/make-a-complaint/complain",
    trust: 4,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "AFCA 공식 안내의 금융회사 내부 민원 우선 원칙과 제출 준비 확인",
    reviewStatus: "live_verified",
    claimScope: "은행 내부 분쟁 해결 후 무료 독립 외부 민원으로 진행하는 기본 순서",
    followUp: "AFCA 접수 전 관할·기한과 필요한 증빙을 현재 안내에서 확인",
  },
  {
    sourceId: "identity-documents-source-receiver-requirements",
    topicId: "identity-documents",
    title: "How to prove your identity",
    publisher: "ASIC Moneysmart",
    url: "https://moneysmart.gov.au/supporting-first-nations-people-with-money-matters/how-to-prove-your-identity",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "Moneysmart 공식 안내의 기관별 신원확인 차이와 대체 자료 문의 절차 확인",
    reviewStatus: "live_verified",
    claimScope: "은행·super fund가 인정하는 신분자료가 기관과 업무에 따라 다르다는 원칙",
    followUp: "제출 직전 수신 기관에 인정 서류·사본 인증·제출 방식 재확인",
  },
  {
    sourceId: "identity-documents-source-alternative-id",
    topicId: "identity-documents",
    title: "Assisting customers who don’t have standard forms of identification",
    publisher: "AUSTRAC",
    url: "https://www.austrac.gov.au/sites/default/files/2024-09/Assisting%20customers%20who%20don%E2%80%99t%20have%20standard%20forms%20of%20identification%20%28clean%20version%29.pdf",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "AUSTRAC 공식 PDF의 위험 기반 대체 신원확인 원칙과 취약 상황 예시 확인",
    reviewStatus: "official_document_verified",
    claimScope: "표준 신분서류를 구할 수 없는 금융 고객을 위한 대체 확인 가능성과 제한",
    followUp: "대체 서류 수용 여부는 해당 금융기관의 현재 절차에서 개별 확인",
  },
  {
    sourceId: "identity-documents-source-digital-id",
    topicId: "identity-documents",
    title: "What is Digital ID?",
    publisher: "Australian Government Digital ID System",
    url: "https://www.digitalidsystem.gov.au/what-is-digital-id",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "Australian Government Digital ID 공식 안내의 자발성·동의·물리 서류 관계 확인",
    reviewStatus: "live_verified",
    claimScope: "Digital ID가 기존 신분서류를 대체하지 않는 자발적 온라인 확인 수단이라는 범위",
    followUp: "이용하려는 서비스가 현재 어떤 Digital ID와 proofing level을 받는지 확인",
  },
  {
    sourceId: "identity-documents-source-digital-id-setup",
    topicId: "identity-documents",
    title: "Set up and manage your Digital ID",
    publisher: "Australian Government Digital ID System",
    url: "https://www.digitalidsystem.gov.au/set-up-and-manage-your-digital-id",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "Digital ID 공식 설정 안내의 문서 확인·accredited provider·보안 관리 절차 확인",
    reviewStatus: "live_verified",
    claimScope: "Digital ID 생성에 쓰이는 기존 문서, 발급기관 검증과 계정·동의 관리",
    followUp: "설정 전 accredited provider 등록과 현재 지원 문서 확인",
  },
  {
    sourceId: "identity-documents-source-dvs",
    topicId: "identity-documents",
    title: "About our identity verification services",
    publisher: "Australian Government IDMatch",
    url: "https://www.idmatch.gov.au/about-our-services",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "Attorney-General’s Department IDMatch 안내에서 DVS 비교 범위와 문서 유형 확인",
    reviewStatus: "live_verified",
    claimScope: "DVS가 이름·생년월일 등 문서 정보를 발급기관 기록과 yes/no로 비교하는 방식",
    followUp: "검증 실패 시 제출 기관과 문서 발급기관에서 입력값·기록 상태를 확인",
  },
  {
    sourceId: "identity-documents-source-naati",
    topicId: "identity-documents",
    title: "NAATI Practitioner Identification",
    publisher: "National Accreditation Authority for Translators and Interpreters",
    url: "https://www.naati.com.au/resources/naati-practitioner-identification/",
    trust: 4,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "NAATI 공식 안내의 CPN·translator stamp와 credential 확인 방법 검토",
    reviewStatus: "live_verified",
    claimScope: "번역자의 NAATI 자격과 번역 stamp·CPN을 확인하는 방법",
    followUp: "번역 주문 전 수신 기관의 언어 방향·stamp·원본 첨부 요구사항 확인",
  },
  {
    sourceId: "phone-internet-source-cis",
    topicId: "phone-internet",
    title: "Choosing the right product or plan",
    publisher: "Australian Communications and Media Authority",
    url: "https://www.acma.gov.au/choosing-right-product-or-plan",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "ACMA 공식 안내에서 Critical Information Summary 제공 의무와 비교 항목 확인",
    reviewStatus: "live_verified",
    claimScope: "통신 요금제의 포함·제외 항목, 비용, 계약기간, roaming과 민원 절차 비교",
    followUp: "가입 직전 통신사의 최신 CIS와 전체 계약 조건을 다시 확인",
  },
  {
    sourceId: "phone-internet-source-coverage",
    topicId: "phone-internet",
    title: "Clearer mobile coverage information: what's changing under new rules",
    publisher: "Australian Communications and Media Authority",
    url: "https://www.acma.gov.au/clearer-mobile-coverage-information-whats-changing-under-new-rules",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "ACMA 공식 안내의 이동통신 coverage map 표시 기준과 이용 한계 확인",
    reviewStatus: "live_verified",
    claimScope: "통신사 coverage map의 outdoor·indoor·in-vehicle 범주와 실제 수신 차이",
    followUp: "가입 직전 정확한 주소와 주 사용 장소를 각 통신사의 최신 지도에서 확인",
  },
  {
    sourceId: "phone-internet-source-porting",
    topicId: "phone-internet",
    title: "Keep or port your phone number",
    publisher: "Australian Communications and Media Authority",
    url: "https://www.acma.gov.au/keep-or-port-your-phone-number",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "ACMA 공식 번호 이동 안내의 활성 번호·신규 통신사 신청·본인확인 절차 확인",
    reviewStatus: "live_verified",
    claimScope: "휴대전화·지역 번호 이동의 기본 절차, 추가 신원 확인과 문제 발생 시 민원 경로",
    followUp: "이동 신청 전 기존 계약 비용과 신규 통신사의 현재 porting 절차 확인",
  },
  {
    sourceId: "phone-internet-source-nbn-plan",
    topicId: "phone-internet",
    title: "Choosing an NBN plan",
    publisher: "Australian Communications and Media Authority",
    url: "https://www.acma.gov.au/choosing-nbn-plan",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "ACMA 공식 NBN 안내에서 key facts sheet, busy-period speed와 장비·정전 확인 항목 검토",
    reviewStatus: "live_verified",
    claimScope: "NBN 요금제 속도·사용 목적·장비·전화번호·정전 시 작동 여부 비교",
    followUp: "주소에서 가능한 기술과 실제 예상 속도를 가입할 통신사에 확인",
  },
  {
    sourceId: "phone-internet-source-hardship",
    topicId: "phone-internet",
    title: "Help if you can't pay your bill",
    publisher: "Australian Communications and Media Authority",
    url: "https://www.acma.gov.au/help-if-you-cant-pay-your-bill",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "ACMA 공식 안내의 payment assistance policy와 연결 유지 중심 지원 의무 확인",
    reviewStatus: "live_verified",
    claimScope: "통신요금 납부 곤란 시 통신사에 요청할 수 있는 payment assistance의 기본 범위",
    followUp: "신청 시 통신사의 최신 payment assistance policy와 본인에게 제시된 조건 확인",
  },
  {
    sourceId: "phone-internet-source-nbn-connect",
    topicId: "phone-internet",
    title: "A guide to getting connected",
    publisher: "nbn",
    url: "https://www.nbnco.com.au/residential/getting-connected",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "nbn 공식 연결 안내에서 주소 확인, 설치·장비와 provider·nbn 문의 범위 확인",
    reviewStatus: "live_verified",
    claimScope: "주소별 NBN 연결 상태, 설치 준비와 장애·속도·장비 문제의 우선 문의처",
    followUp: "설치 전 주소 결과와 선택 기술에 맞는 장비·appointment·추가 비용 확인",
  },
  {
    sourceId: "phone-internet-source-complaints",
    topicId: "phone-internet",
    title: "Help with phone and internet problems",
    publisher: "Telecommunications Industry Ombudsman",
    url: "https://www.tio.com.au/help-phone-and-internet-problems",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "TIO 공식 안내에서 통신사 우선 민원과 무료 외부 분쟁 해결 범위 확인",
    reviewStatus: "live_verified",
    claimScope: "요금·계약·연결·장애·financial hardship 문제의 통신사 및 TIO 민원 순서",
    followUp: "TIO 접수 전 통신사 complaint reference와 문제·원하는 해결 결과를 정리",
  },
  {
    sourceId: "home-utilities-source-compare",
    topicId: "home-utilities",
    title: "Switch to save",
    publisher: "Australian Government Department of Climate Change, Energy, the Environment and Water",
    url: "https://www.energy.gov.au/households/find-the-best-energy-deal",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "energy.gov.au 공식 안내에서 주·준주별 정부 비교 도구와 요금 구성 확인",
    reviewStatus: "live_verified",
    claimScope: "지역별 전기·가스 비교 경로, supply·usage charge와 요금제 비교 원칙",
    followUp: "주소의 주·준주와 공급 지역에 맞는 현재 정부 비교 도구를 사용",
  },
  {
    sourceId: "home-utilities-source-moving",
    topicId: "home-utilities",
    title: "Energy services",
    publisher: "Australian Energy Regulator",
    url: "https://www.aer.gov.au/consumers/understanding-energy/energy-services",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "AER 공식 안내에서 이사 통지, 새 주소 계정 개설과 최종 청구 절차 확인",
    reviewStatus: "live_verified",
    claimScope: "NECF 지역의 이사 전후 전기·가스 계정 시작·종료와 retailer 변경 기본 절차",
    followUp: "Victoria·WA·NT 또는 embedded network는 해당 지역 규정과 제공자 절차를 별도 확인",
  },
  {
    sourceId: "home-utilities-source-bill",
    topicId: "home-utilities",
    title: "Your energy bill",
    publisher: "Australian Energy Regulator",
    url: "https://www.aer.gov.au/consumers/understanding-energy/understanding-your-energy-bill",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "AER 공식 안내에서 bill의 주소·기간·meter number·actual/estimate·요금 항목 확인",
    reviewStatus: "live_verified",
    claimScope: "QLD·NSW·ACT·SA·TAS 에너지 bill 검토와 payment difficulty 기본 안내",
    followUp: "다른 관할과 embedded network는 지역 regulator 또는 ombudsman 안내 확인",
  },
  {
    sourceId: "home-utilities-source-rights",
    topicId: "home-utilities",
    title: "Your energy rights",
    publisher: "Australian Energy Regulator",
    url: "https://www.aer.gov.au/consumers/understanding-energy/your-energy-rights",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "AER 공식 안내에서 명확한 계약·bill·hardship·이사 통지와 life support 책임 확인",
    reviewStatus: "live_verified",
    claimScope: "National Energy Retail Law 적용 지역의 소비자 권리·책임과 지원 범위",
    followUp: "현재 주소의 NECF 적용 여부와 지역별 추가 보호를 regulator에서 확인",
  },
  {
    sourceId: "home-utilities-source-complaints",
    topicId: "home-utilities",
    title: "Make a complaint",
    publisher: "Australian Energy Regulator",
    url: "https://www.aer.gov.au/consumers/have-your-say/make-complaint",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "AER 공식 안내에서 retailer·distributor 문의 범위와 주별 ombudsman 단계 확인",
    reviewStatus: "live_verified",
    claimScope: "요금·계약은 retailer, outage·network는 distributor, 미해결 분쟁은 지역 ombudsman으로 진행하는 기본 경로",
    followUp: "민원 전 제공자 complaint reference와 해당 주·준주의 ombudsman 관할 확인",
  },
  {
    sourceId: "home-utilities-source-renters",
    topicId: "home-utilities",
    title: "Renters",
    publisher: "Australian Government Department of Climate Change, Energy, the Environment and Water",
    url: "https://www.energy.gov.au/households/household-guides/life-stages-advice/renters",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "energy.gov.au 공식 임차인 안내에서 주별 법 차이, 임대인 허가와 물·에너지 관리 범위 확인",
    reviewStatus: "live_verified",
    claimScope: "임차 주택의 에너지·수도 책임이 lease, 계량과 주별 법에 따라 달라지는 원칙",
    followUp: "수도요금·수리·계량 책임은 lease와 해당 주 tenancy authority에서 재확인",
  },
  {
    sourceId: "rent-increase-source-nsw-rules",
    topicId: "rent-increase",
    title: "When and how rent can be increased",
    publisher: "NSW Fair Trading (NSW Government)",
    url: "https://www.nsw.gov.au/housing-and-construction/rules/when-and-how-rent-can-be-increased",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-18",
    verificationMethod: "공식 페이지 본문 확인 - 60일 서면 통지, 12개월 1회 인상 제한(2024-10-31부터), 2024-12-13 이전 고정계약 예외 확인",
    reviewStatus: "live_verified",
    claimScope: "NSW 렌트 인상 통지 기간(60일)과 인상 주기(12개월 1회) 규정",
    followUp: "NSW 외 다른 주(VIC/QLD 등)는 통지 기간과 인상 주기 규정이 다르므로 거주 주(state)의 공식 tenancy 규정을 별도 확인해야 한다 - 지금은 NSW 규정만 확인했다.",
  },
  {
    sourceId: "medicare-levy-source-ato-overview",
    topicId: "medicare-levy",
    title: "Medicare levy",
    publisher: "Australian Taxation Office",
    url: "https://www.ato.gov.au/individuals-and-families/medicare-and-private-health-insurance/medicare-levy",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-18",
    verificationMethod: "공식 페이지 본문 확인 - Medicare levy 개요와 감면·면제 하위 페이지 링크 확인",
    reviewStatus: "live_verified",
    claimScope: "Medicare levy가 부과되는 원리와 감면·면제 신청 경로가 있다는 사실",
    followUp: "본인 소득 구간별 정확한 감면 기준액은 매 회계연도 갱신되므로 신고 시점의 ATO 페이지에서 재확인 필요",
  },
  {
    sourceId: "address-change-source-servicesaustralia",
    topicId: "address-change",
    title: "Changing your address if you're moving house",
    publisher: "Services Australia",
    url: "https://www.servicesaustralia.gov.au/changing-your-address-if-youre-moving-house",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-18",
    verificationMethod: "공식 페이지 본문 확인 - myGov 주소 변경 시 일부 연결 서비스로 자동 전송 가능, Centrelink 지급 수급자는 14일 이내 변경 권고 확인",
    reviewStatus: "live_verified",
    claimScope: "Services Australia 연결 서비스의 주소 변경 경로와 Centrelink 지급 수급자의 14일 이내 변경 권고",
    followUp: "은행·면허·우편물 전달 등 정부기관 외 항목은 각 기관 사이트에서 개별 확인 필요",
  },
  {
    sourceId: "address-change-source-mygov-profile",
    topicId: "address-change",
    title: "How to update your details in myGov",
    publisher: "myGov (Australian Government)",
    url: "https://my.gov.au/en/about/help/mygov-website/help-using-your-account/how-to-update-your-personal-and-contact-details-in-mygov",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-18",
    verificationMethod: "공식 페이지 본문 확인 - myGov 프로필 주소 변경 후 연결된 ATO·Centrelink·Medicare 등에 변경 주소를 선택적으로 전송할 수 있는 절차 확인",
    reviewStatus: "live_verified",
    claimScope: "myGov 프로필에서 주소를 바꾸고 지원되는 연결 서비스에 변경 정보를 공유하는 절차",
    followUp: "지원 목록에 없는 서비스와 은행·면허·우편물 전달은 각 기관에서 별도 변경 필요",
  },
  {
    sourceId: "visa-status-source-vevo-overview",
    topicId: "visa-status-check",
    title: "Check visa details and conditions (VEVO)",
    publisher: "Department of Home Affairs",
    url: "https://immi.homeaffairs.gov.au/visas/already-have-a-visa/check-visa-details-and-conditions/overview",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-18",
    verificationMethod: "공식 페이지 본문 확인 - VEVO가 제공하는 정보(비자 종류/만료일/체류기간/조건) 확인",
    reviewStatus: "live_verified",
    claimScope: "VEVO로 본인 비자의 종류·만료일·체류기간·조건을 공식으로 조회할 수 있다는 사실",
    followUp: "1990년 이전 입국해 해외 출국 기록이 없는 영주권자는 전자 기록이 없을 수 있어 별도 신청 경로 확인 필요",
  },
  {
    sourceId: "visa-conditions-source-vevo-conditions",
    topicId: "visa-conditions",
    title: "Check visa details and conditions (VEVO)",
    publisher: "Department of Home Affairs",
    url: "https://immi.homeaffairs.gov.au/visas/already-have-a-visa/check-visa-details-and-conditions/overview",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-18",
    verificationMethod: "공식 페이지 본문 확인 - VEVO가 비자별 조건(할 수 있는 것/없는 것)을 제공한다는 설명 확인",
    reviewStatus: "live_verified",
    claimScope: "VEVO로 본인 비자에 실제로 붙은 조건을 확인할 수 있다는 사실",
    followUp: "조건 해석이 애매하거나 조건 위반 우려가 있으면 등록 이민 에이전트(MARN) 상담이 필요 - 이 페이지는 조회 방법만 안내한다.",
  },
] as const satisfies readonly TopicContentSource[];

export function getTopicContentSources(topicId: string): TopicContentSource[] {
  return TOPIC_CONTENT_SOURCES.filter((source) => source.topicId === topicId);
}

export function getTopicContentSource(
  sourceId: string,
): TopicContentSource | undefined {
  return TOPIC_CONTENT_SOURCES.find((source) => source.sourceId === sourceId);
}
